import { render, staticRenderFns } from "./ProxiesView.vue?vue&type=template&id=7613bb60&"
import script from "./ProxiesView.vue?vue&type=script&lang=js&"
export * from "./ProxiesView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports